import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';


/**
 * The list of tabs on this page
 */
export enum ExperienceSchedulingPageTabId {
	Experience = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum ExperienceSchedulingPageViewId {
	CurriculumSchedules = 1,
	AcceleratorCourseAssignments = 2,
}


@Injectable({ providedIn: 'root' })
export class ExperienceSchedulingService extends PageTabsLayoutPageService<ExperienceSchedulingPageTabId, ExperienceSchedulingPageViewId> {
	private static readonly _viewDroplistItems1: DroplistItem<never, ExperienceSchedulingPageViewId>[] = [
		{
			uniqueId: ExperienceSchedulingPageViewId.CurriculumSchedules, iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Curriculum Schedules',
				hideText: 'never',
			},
			customSort: '1-CurriculumSchedules'
		},
		{
			uniqueId: ExperienceSchedulingPageViewId.AcceleratorCourseAssignments, iconContext: {
				iconClass: 'fa-user-graduate',
				iconStyle: 'fa-solid',
				text: 'Accelerator Course Assignments',
				hideText: 'never',
			},
			customSort: '2-AcceleratorCourseAssignments'
		},
	];

	constructor() {
		super(ExperienceSchedulingService._viewDroplistItems1, ExperienceSchedulingService.name, ExperienceSchedulingPageTabId.Experience, ExperienceSchedulingPageViewId.CurriculumSchedules);
	}

	public get viewId() {
		return ExperienceSchedulingPageViewId;
	}
}